export const FEATURES_QUERY_REACTIONS = 'features-reactions';
export const FEATURES_QUERY_VISITS = 'features-visits';
export const FEATURES_QUERY_SENT = 'features-sent';
